import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { PROFILE as DEFAULT_PROFILE } from "../data/profile";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ProfileContext = createContext(DEFAULT_PROFILE);

export function ProfileProvider({ children }) {
  const [profile, setProfile] = useState(DEFAULT_PROFILE);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/content`);
        if (cancelled || !data || Object.keys(data).length === 0) return;
        setProfile({ ...DEFAULT_PROFILE, ...data });
      } catch {
        // silent — keep defaults
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return <ProfileContext.Provider value={profile}>{children}</ProfileContext.Provider>;
}

export function useProfile() {
  return useContext(ProfileContext);
}
